import { render, staticRenderFns } from "./RecepcionSubTab.vue?vue&type=template&id=e297d2d0&"
import script from "./RecepcionSubTab.vue?vue&type=script&lang=js&"
export * from "./RecepcionSubTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports